<template>
    <CommonChart :data="data" :config="chartConfig" :customers="customers" :selectedPeriod="selectedPeriod"
        :customerDataField="'reqAmt'" :tooltipUnit="'원'" :yAxisName="'청구 금액 (원)'" :yAxisFormatter="yAxisFormatter"
        :boundaryGap="true" containerClass="chart-container" />
</template>

<script>
import CommonChart from "../common/CommonChart.vue";
import { getPrimaryBlueColor } from "../../utils/colorUtils.js";

export default {
    name: "DashboardBillTrendChart",
    components: {
        CommonChart,
    },
    props: {
        data: {
            type: Array,
            default: () => [],
        },
        customers: {
            type: Array,
            default: () => [],
        },
        selectedPeriod: {
            type: String,
            default: "monthly",
        },
    },
    computed: {
        chartConfig() {
            const lastIndex = this.data && this.data.length > 0 ? this.data.length - 1 : -1;
            return [
                {
                    name: "전체 청구 금액",
                    type: "bar",
                    dataField: "totalReqAmt",
                    color: "#cbd5e1",
                    highlightItem: lastIndex,
                    highlightColor: getPrimaryBlueColor(),
                    borderRadius: [10, 10, 0, 0],
                    yAxis: {
                        name: "청구 금액 (원)",
                        formatter: this.yAxisFormatter,
                    },
                    barWidth: "60%",
                },
            ];
        },
        yAxisFormatter() {
            return (value) => {
                if (value >= 100000000) {
                    return (value / 100000000).toFixed(1) + "억";
                } else if (value >= 10000) {
                    return (value / 10000).toFixed(0) + "만";
                }
                return value.toLocaleString();
            };
        },
    },
};
</script>

<style scoped>
.chart-container {
    width: 100%;
    height: 100%;
    min-height: 0;
    min-width: 0;
}
</style>
